//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    hasMedia: {
      type: Boolean,
      default: false
    },

    rowHasMedia: {
      type: Boolean,
      default: false
    },

    link: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'small'
        ].includes(value)
      }
    }
  },

  computed: {
    isClickable () {
      return !!this.link
    },

    classes () {
      return {
        BaseStack: true,
        'BaseStack--clickable': this.isClickable,
        [`BaseStack--${this.size}`]: this.size,
        'BaseStack--no-media': !this.hasMedia && this.rowHasMedia
      }
    }
  }
}
